import { PricePlanPeriodPureType, PricePlanPureType } from '@shared/api/graphql/generated';

export const getDiscount = (
  pricePlan: PricePlanPureType,
  currentPeriod: PricePlanPeriodPureType,
  licensesCount: number
): number => {
  if (!pricePlan) return 0;

  const targetRowIndex = pricePlan.periods[0].rows.findIndex(
    ({ stepRangeLower, stepRangeUpper }) =>
      licensesCount >= stepRangeLower && licensesCount <= (stepRangeUpper || Number.MAX_SAFE_INTEGER) - 1
  );

  const maxAmount = pricePlan.periods[0].rows[targetRowIndex === -1 ? 0 : targetRowIndex].amount;
  const maxAmountPerMonth = maxAmount / pricePlan.periods[0].payFrequencyMonth;

  const currentAmount = currentPeriod.rows[targetRowIndex || 0].amount;
  const currentAmountPerMonth = currentAmount / currentPeriod.payFrequencyMonth;

  const discount =
    maxAmountPerMonth > currentAmountPerMonth
      ? Math.trunc(((maxAmountPerMonth - currentAmountPerMonth) / maxAmountPerMonth) * 100)
      : Math.trunc(((currentAmountPerMonth - maxAmountPerMonth) / maxAmountPerMonth) * 100);

  const discountWithSign = maxAmountPerMonth < currentAmountPerMonth ? 0 : discount;

  return discountWithSign;
};
